import { render, staticRenderFns } from "./AppBenifits.vue?vue&type=template&id=2d4c8d52&scoped=true&"
var script = {}
import style0 from "./AppBenifits.vue?vue&type=style&index=0&id=2d4c8d52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4c8d52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d4c8d52')) {
      api.createRecord('2d4c8d52', component.options)
    } else {
      api.reload('2d4c8d52', component.options)
    }
    module.hot.accept("./AppBenifits.vue?vue&type=template&id=2d4c8d52&scoped=true&", function () {
      api.rerender('2d4c8d52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/page_eagle_landing/components/AppBenifits.vue"
export default component.exports